// extracted by mini-css-extract-plugin
export default {"productGallery":"OL-z","inQuickShop":"PL-z"};